<script setup lang="ts">
import { Plus } from "@lucide/vue";

withDefaults(defineProps<{ label?: string }>(), { label: "Add reference area" });

const emit = defineEmits<{
  addReferenceArea: [];
}>();

const addReferenceArea = () => {
  emit("addReferenceArea");
};
</script>

<template>
  <button
    type="button"
    data-cy="add-reference-area-btn"
    class="rounded-8 bg-slate-0 text-type-default focus-ring interactive-active duration-fast ease-standard ring-slate-250 inline-flex w-fit shrink-0 items-center gap-2 p-2 ring-1 transition-all hover:bg-slate-100 hover:ring-slate-300"
    @click="addReferenceArea">
    <Plus
      class="icon-sm shrink-0"
      :stroke-width="1.5"
      color="var(--color-app-blue-800)"
      fill="var(--color-app-blue-100)" />
    <span class="t-small-bold whitespace-nowrap">{{ label }}</span>
  </button>
</template>
